import { publicRequest } from "../../../requestMeth";

const authHeaders = (token) => ({ token: `Bearer ${token}` });

export const getProjects = async (token, params = {}) => {
  const res = await publicRequest.get("/projects", {
    headers: authHeaders(token),
    params,
  });
  return res.data;
};

export const getProjectById = async (id, token) => {
  const res = await publicRequest.get(`/projects/${id}`, {
    headers: authHeaders(token),
  });
  return res.data;
};

export const createProject = async (data, token) => {
  const res = await publicRequest.post("/projects", data, {
    headers: authHeaders(token),
  });
  return res.data;
};

export const updateProject = async (id, data, token) => {
  const res = await publicRequest.put(`/projects/${id}`, data, {
    headers: authHeaders(token),
  });
  return res.data;
};

export const pauseProject = async (id, token) => {
  const res = await publicRequest.post(`/projects/${id}/pause`, {}, {
    headers: authHeaders(token),
  });
  return res.data;
};

export const resumeProject = async (id, scheduleAction, token) => {
  const res = await publicRequest.post(`/projects/${id}/resume`, {
    schedule_action: scheduleAction,
  }, {
    headers: authHeaders(token),
  });
  return res.data;
};

export const getProjectUsers = async (token) => {
  const res = await publicRequest.get("/admin/users", {
    headers: authHeaders(token),
  });
  return res.data;
};

export const getProjectDevices = async (token) => {
  const res = await publicRequest.get("/admin/devices", {
    headers: authHeaders(token),
  });
  return res.data;
};

export const getProjectCompanies = async (token) => {
  const res = await publicRequest.get("/master/companies", {
    headers: authHeaders(token),
    params: { type: "company" },
  });
  return res.data;
};

export const getProjectBranches = async (token) => {
  const res = await publicRequest.get("/master/companies", {
    headers: authHeaders(token),
    params: { type: "branch_offices" },
  });
  return res.data;
};

export const getProjectTasks = async (projectId, token) => {
  const res = await publicRequest.get(`/projects/${projectId}/tasks`, {
    headers: authHeaders(token),
  });
  return res.data;
};

export const createProjectTask = async (projectId, data, token) => {
  const res = await publicRequest.post(`/projects/${projectId}/tasks`, data, {
    headers: authHeaders(token),
  });
  return res.data;
};

export const updateProjectTask = async (projectId, taskId, data, token) => {
  const res = await publicRequest.put(
    `/projects/${projectId}/tasks/${taskId}`,
    data,
    { headers: authHeaders(token) },
  );
  return res.data;
};
